
import {defineComponent,reactive, toRefs, onMounted} from 'vue'
import { useRouter} from "vue-router";
import {getLogListAPI} from '@/service/api'
import {ElMessage} from 'element-plus'


export default defineComponent({
  props: {
    id: {
      type: String,
      default: ''
    }
  },
  setup(props, ctx) {
    const router = useRouter()
    const state = reactive({
      apiParams:{
        limit: 10,
        page: 1,
        q: ''
      },
      logList: [] as any[],
      total: 0,
      pageCount: 0,
      loading: false
    })


    const getLogList = ()=>{
      state.loading = true
      getLogListAPI({
        ...state.apiParams,
        appId: props.id
      }).then((res:any)=>{
        if(res.code === 1){
          state.logList = res.data.rows
          state.total = res.data.total_rows
          state.pageCount = res.data.page_count
        }else{
          ElMessage.warning(res.msg)
        }
      }).catch((err: any)=>{
        ElMessage.warning(err.msg)
      }).finally(()=>{
        state.loading = false
      })
    }

    const switchPage = (page:number=1)=>{
      state.apiParams.page = page
      state.logList = []
      state.total = 0
      state.pageCount = 0
      getLogList()
    }

    const lookAppLog = (id:string)=>{
      router.replace({
        path: '/log/app',
        query:{id}
      })
      switchPage()
    }

    const onSearch =()=>{
      switchPage()
    }

    const back = ()=>{
      router.back()
    }

    onMounted(()=>{
      switchPage()
    })

    return {
      ...toRefs(state),
      lookAppLog,
      switchPage,
      onSearch,
      back
    }
  }
})
